import { Tabs } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Menus from './Menus';
import MyMeeting from './MyMeeting';
import HistoryMeeting from './HistoryMeeting';
import Sider from './Sider';
import BookingMeeting from '@/components/BookingMeeting';
import BookingCancel from '@/components/BookingCancel';
import BookingDetail from '@/components/BookingDetail';
import ModalMeetingShare from '@/components/HOC/ModalMeetingShare';

function App() {
  const KEY_0 = '0';
  const KEY_1 = '1';
  const [activeKey, setActiveKey] = useState<string>(KEY_0);
  const { t } = useTranslation();

  return (
    <>
      <div className='flex'>
        <Menus />
        <div className='flex h-screen flex-1 flex-col'>
          <Sider />
          <Tabs
            activeKey={activeKey}
            items={[
              { key: KEY_0, label: <span className='text-[16px]'>{t('myMeeting')}</span> },
              { key: KEY_1, label: <span className='text-[16px]'>{t('historyMeeting')}</span> },
            ]}
            onChange={(key) => setActiveKey(key)}
            tabBarStyle={{
              marginBottom: 0,
              paddingLeft: 12,
              paddingRight: 12,
              height: 60,
              borderColor: '#f00',
            }}
          />
          <div className='flex-1 overflow-hidden'>{activeKey === KEY_0 ? <MyMeeting /> : <HistoryMeeting />}</div>
        </div>
      </div>
      <ModalMeetingShare />
      <BookingMeeting />
      <BookingCancel />
      <BookingDetail />
    </>
  );
}

export default App;
